import {Inject, Injectable} from '@angular/core';
import {ComponentStore} from '@ngrx/component-store';
import {ManageConditionalDimensionDialogState} from './manage-conditional-dimension-dialog';
import {Observable, Subscription} from 'rxjs';
import {DimensionComponentObject} from '../../../../../shared/classes/dimension-component-object';
import {AppState} from '../../../../../shared/store/store';
import {Store} from '@ngrx/store';
import {filter, tap} from 'rxjs/operators';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {FormArray, FormControl, FormGroup, Validators} from '@angular/forms';
import {
  DatasetConditionalDimensionComponentObject,
  DatasetConditionalDimensionRuleConditionComponentObject,
  DatasetConditionalDimensionRuleConditionComponentObjects
} from '../../../../../shared/classes/dataset-conditional-dimension-component-object';
import {
  selectDataSetConditionalDimensionsInitialized
} from '../../../../../shared/store/dataSetConditionalDimensions/dataSetConditionalDimensions.selectors';

@Injectable()
export class ManageConditionalDimensionDialogStore extends ComponentStore<ManageConditionalDimensionDialogState> {
  public readonly form: FormGroup<{
    name: FormControl<string>,
    visibility: FormControl<any>,
    category: FormControl<any>,
    rules: FormArray<FormGroup<{
      groups: FormArray<FormGroup<{
        dimension: FormControl<DimensionComponentObject>,
        operator: FormControl<any>,
        value: FormControl<any>,
        conditionOperator: FormControl<'or' | 'and' | null>,
        valid: FormControl<boolean>
      }>>,
      thenAction: FormControl<any>,
      then: FormControl<any>,
      valid: FormControl<boolean>
    }>>,
    elseAction: FormControl<any>,
    else: FormControl<any>,
    valid: FormControl<boolean>
  }> = new FormGroup({
    name: new FormControl(null, [Validators.required]),
    visibility: new FormControl(null, [Validators.required]),
    category: new FormControl(null, [Validators.required]),
    rules: new FormArray([], [Validators.required]),
    elseAction: new FormControl('fixed_value', [Validators.required]),
    else:  new FormControl(null, [Validators.required]),
    valid: new FormControl(true, [Validators.required]),
  });

  private readonly _dimensionsInitialized$: Observable<boolean> = this._store.select(selectDataSetConditionalDimensionsInitialized);

  private _init$: Subscription = this.effect((): Observable<boolean> => this._dimensionsInitialized$.pipe(
    filter((loaded: boolean) => loaded && 'payload' in this.conditionalDimension),
    tap((): void => this._initForm())
  ));

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly conditionalDimension: DatasetConditionalDimensionComponentObject,
    private readonly _store: Store<AppState>
  ) {
    super();
  }

  private _initForm(): void {
    this.form.patchValue({
      name: this.conditionalDimension.name$.value,
      visibility: this.conditionalDimension.payload.attributes.visibility,
      category: this.conditionalDimension.payload.attributes.data_set_dimensions_group_id.toString(),
      elseAction: this.conditionalDimension.else$.value.action$.value,
      else: this.conditionalDimension.else$.value.action$.value === 'no_value' && null || this.conditionalDimension.else$.value.action$.value === 'fixed_value' && this.conditionalDimension.else$.value.value$.value || this.conditionalDimension.else$.value.dimension$.value,
      valid: this.conditionalDimension.valid$.value
    });

    if(this.conditionalDimension.else$.value.action$.value !== 'no_value')
      this.form.controls.else.addValidators([Validators.required])
    else
      this.form.controls.else.removeValidators([Validators.required])


    for (const rule of this.conditionalDimension.rules$.value) {
      this.form.controls.rules.push(new FormGroup({
        groups: new FormArray(
          rule.rules$.value.reduce((output: Array<FormGroup>, rules: DatasetConditionalDimensionRuleConditionComponentObjects) => output.concat(rules.map((rule: DatasetConditionalDimensionRuleConditionComponentObject, i: number): FormGroup => new FormGroup<any>({
            dimension: new FormControl(rule.dimensionObject$.value, [Validators.required]),
            operator: new FormControl(rule.operator$.value, [Validators.required]),
            value: new FormControl(rule.value$.value, [Validators.required]),
            conditionOperator: new FormControl(i === 0 && 'or' || 'and'),
            valid: new FormControl(rule.valid$.value)
          }))), [] as Array<FormGroup>),
          [Validators.required]
        ),
        thenAction: new FormControl(rule.thenAction$.value, [Validators.required]),
        then: new FormControl(rule.thenAction$.value === 'fixed_value' && rule.then$.value || rule.dimension$.value, [Validators.required]),
        valid: new FormControl(rule.valid$.value)
      }));
    }
  }

}
